import {
  fetchLines,
  fetchTrains,
  fetchStationDetail,
  fetchNotifications,
  receiveNotification,
  receiveTrainPosition,
  receiveLines,
  receiveStationDetail,
  closeStationDetail,
} from '../actions'
import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import StationDetail from '../components/station/StationDetail'

const mapStateToProps = (state, _props) => {
  const {
    lines,
    trains, 
    notifications,
    nankai_update_date,
    nankai_update_time,
    koya_update_date,
    koya_update_time,
    nankai_scheduleTypes,
    koya_scheduleTypes,
    up,
    down,
    has_window,
  } = state.stationReducer
  const { themeName } = state.themeReducer

  return {
    lines,
    trains, 
    notifications,
    nankai_update_date,
    nankai_update_time,
    koya_update_date,
    koya_update_time,
    nankai_scheduleTypes,
    koya_scheduleTypes,
    up,
    down,
    has_window,
    themeName,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchNotifications: async () => {
      try {
        const payload = await fetchNotifications()
        dispatch(receiveNotification(payload))
      } catch (error) {
        showAlert('運行情報が取得できませんでした')
      }
    },
    fetchLines: async () => {
      try {
        const payload = await fetchLines()
        dispatch(receiveLines(payload))
      } catch (error) {
        showAlert('路線が取得できませんでした')
      }
    },
    fetchTrains: async () => {
      try {
        const payload = await fetchTrains()
        dispatch(receiveTrainPosition(payload))
      } catch (error) {
        showAlert('在線情報が取得できませんでした')
      }
    },
    fetchStationDetail: async (lineId, stationId, update_time, scheduleTypes) => {
      try {
        const payload = await fetchStationDetail(lineId, scheduleTypes, stationId, update_time)
        dispatch(receiveStationDetail(payload))
      } catch (error) {
        showAlert('駅情報が取得できませんでした')
      }
    },
    closeStationDetail: () => {
      dispatch(closeStationDetail())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationDetail)